// removed by extract-text-webpack-plugin
module.exports = {"root":"watch-as-logo__root","authState":"watch-as-logo__authState","check":"watch-as-logo__check watch-as-logo__authState","key":"watch-as-logo__key watch-as-logo__authState","logo":"watch-as-logo__logo"};


//////////////////
// WEBPACK FOOTER
// ./src/common/components/watch-as-logo/styles.less
// module id = 168
// module chunks = 1 2